import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '../components/SuperAdminLayout';
import { useCustomDialog } from '../context/DialogContext';
import '../styles/superadmin.css';

const BASE = 'https://menu.searchisend.in';

const ImageRequests = () => {
    const navigate = useNavigate();
    const { alert: customAlert, confirm: customConfirm } = useCustomDialog();
    const token = localStorage.getItem('saas_superadmin_token');
    
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('Pending');

    const fetchRequests = async (status, silent = false) => {
        if (!silent) setLoading(true);
        try {
            const res = await fetch(`${BASE}/apimenu/v2/v2_super_images.php?action=fetch_image_requests&status=${encodeURIComponent(status)}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setRequests(data.requests);
            } else {
                if (!silent) await customAlert(data.message || 'Error fetching requests', 'Error', 'danger');
            }
        } catch (err) {
            console.error('Error fetching requests', err);
        } finally {
            if (!silent) setLoading(false);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate('/superadmin_v2_secure_login');
            return;
        }
        fetchRequests(statusFilter, false);

        const pollInterval = setInterval(() => {
            fetchRequests(statusFilter, true);
        }, 10000);

        return () => clearInterval(pollInterval);
        // eslint-disable-next-line
    }, [statusFilter]);

    const handleFilterChange = (e) => {
        const val = e.target.value;
        setStatusFilter(val);
        fetchRequests(val, false);
    };

    const handleToggleStatus = async (requestId, currentStatus) => {
        const newStatus = currentStatus === 'Pending' ? 'Completed' : 'Pending';
        if (!await customConfirm(`Mark this request as ${newStatus}?`, 'Change Status', 'warning')) return;

        try {
            const res = await fetch(`${BASE}/apimenu/v2/v2_super_images.php?action=update_status`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ request_id: requestId, status: newStatus })
            });
            const data = await res.json();
            if (data.success) {
                fetchRequests(statusFilter);
            } else {
                await customAlert(data.message || 'Error updating status', 'Error', 'danger');
            }
        } catch (err) {
            await customAlert('Network error while updating status', 'Error', 'danger');
        }
    };

    return (
        <SuperAdminLayout>
                    <h2 className="sa-page-title">Manage Image Requests</h2>
                    <p className="sa-page-subtitle">Review and manage image requests submitted by your customers.</p>

                    <div className="sa-action-bar">
                        <div className="sa-filters">
                            <i className="fas fa-filter" style={{ color: 'var(--text-secondary)' }}></i>
                            <select 
                                className="sa-select"
                                style={{ border: 'none', background: 'transparent', boxShadow: 'none', padding: '5px', fontWeight: 500 }}
                                value={statusFilter} 
                                onChange={handleFilterChange}
                            >
                                <option value="">All Statuses</option>
                                <option value="Pending">Pending</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </div>
                        <button onClick={() => fetchRequests(statusFilter)} className="sa-primary-btn"><i className="fas fa-sync-alt"></i> Refresh</button>
                    </div>

                    <div className="sa-table-container">
                        <table className="sa-table">
                            <thead>
                                <tr>
                                    <th>Restaurant</th>
                                    <th>Request Message</th>
                                    <th>Status</th>
                                    <th>Date Requested</th>
                                    <th style={{ textAlign: 'right' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="5" style={{ padding: '4rem', textAlign: 'center', color: 'var(--text-secondary)' }}><i className="fas fa-circle-notch fa-spin fa-2x"></i></td></tr>
                                ) : requests.length === 0 ? (
                                    <tr><td colSpan="5" style={{ padding: '4rem', textAlign: 'center', color: 'var(--text-secondary)' }}>No image requests found for this status.</td></tr>
                                ) : requests.map((req) => (
                                    <tr key={req.request_id}>
                                        <td>
                                            <div style={{ fontWeight: 700, color: 'var(--text-primary)' }}>{req.restaurant_name}</div>
                                            <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>@{req.username}</div>
                                        </td>
                                        <td style={{ whiteSpace: 'pre-line' }}>{req.request_message}</td>
                                        <td>
                                            <span className={`status-badge ${req.status === 'Completed' ? 'status-active' : 'status-paused'}`}>
                                                {req.status}
                                            </span>
                                        </td>
                                        <td>{new Date(req.requested_at).toLocaleString()}</td>
                                        <td style={{ textAlign: 'right' }}>
                                            {req.status === 'Pending' ? (
                                                <button onClick={() => handleToggleStatus(req.request_id, req.status)} className="sa-action-btn success" title="Mark as Completed">
                                                    <i className="fas fa-check"></i> Mark Completed
                                                </button>
                                            ) : (
                                                <button onClick={() => handleToggleStatus(req.request_id, req.status)} className="sa-action-btn" title="Mark as Pending" style={{ color: 'var(--warning)' }}>
                                                    <i className="fas fa-undo"></i> Mark Pending
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
        </SuperAdminLayout>
    );
};

export default ImageRequests;
